import axios from "axios";
import React, { useState } from "react";
import { CiUser, CiEdit, CiTrash } from "react-icons/ci";
import { LuPlus } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";
const QuestionList = ({ props }) => {
  const { ques, assignmentId, setAssignments, assignment } = props;
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const token = Utils.getToken();
  const showToast = useToast();
  const [oldQuestions, setOldQuestions] = useState(
    JSON.parse(JSON.stringify(ques))
  );

  const [questions, setQuestions] = useState(ques);
  const [deletedQuestions, setDeletedQuestions] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const handleAddQuestion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setQuestions([...questions, { question: "", maxMarks: 0 }]);
  };

  const handleDeleteQuestion = (idx) => {
    const confirm = window.confirm("Alert you sure ?");
    if (!confirm) return;

    const delQues = questions[idx];
    if (delQues._id) {
      setDeletedQuestions((prev) => [...prev, delQues._id]);
    }
    const updatedQuestion = questions.filter((_, i) => i !== idx);
    setQuestions(updatedQuestion);
  };

  const handleQuestionChange = (index, field, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index][field] = value;
    setQuestions(updatedQuestions);
  };

  const HandleQuestionsUpdate = async (e) => {
    e.preventDefault();
    const changedQuestions = questions.filter((q1) => {
      const matchingOldQuestion = oldQuestions.find(
        (q2) => q1._id && q1._id === q2._id
      );
      return (
        matchingOldQuestion &&
        (q1.question !== matchingOldQuestion.question ||
          q1.maxMarks != matchingOldQuestion.maxMarks)
      );
    });

    const newQuestions = questions
      .filter((q1) => !q1._id || !oldQuestions.some((q2) => q1._id === q2._id))
      .map((q) => {
        const marks = parseInt(q.maxMarks, 10);
        const MM = !isNaN(marks) && marks > 0 ? marks : -1;
        return { ...q, maxMarks: MM };
      });

    const confirm = window.confirm("Are you sure ?");
    if (!confirm) return;

    try {
      const response = await axios.patch(
        `${SERVER_URL}/assignments/questions/${assignmentId}`,
        {
          newQuestions: newQuestions,
          updateQuestions: changedQuestions,
          deleteQuestions: deletedQuestions,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        const res = response.data;
        const updated = res.assignment;
        showToast(res.message, "success", true, 3000);
        setAssignments((prev) =>
          prev.filter((item) => (item._id === updated._id ? updated : item))
        );
      } else {
        const res = response.data;
        showToast(res.message, "warning", true, 3000);
      }

      setEditMode(false);
    } catch (error) {
      // console.error("Response Catch ", error);
      showToast(
        error.message + " Or Changes may reflect after refresh",
        "error",
        true,
        3000
      );
    }
  };

  return (
    <table
      className="table bg-white animate-show shadow-inner p-4"
      bkl="QuestionList"
      key={"QuestionList" + assignmentId}
    >
      <thead>
        <tr key={"Header" + assignmentId}>
          <th className="w-[5%]">Sr.</th>
          <th className="w-[60%]">Questions</th>
          <th className="w-[15%]">Maximum Marks</th>
          <th className="w-[17%]">
            {/* {!assignment.assigned && ( */}
            <div className="flex gap-2">
              {editMode ? (
                <>
                  {/* Cancel Button */}
                  <button
                    onClick={() => setEditMode(false)}
                    className="px-2 py-1 flex font-[400] gap-1 tracking-[.1em] uppercase border border-orange-600 rounded-lg text-orange-700 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg"
                  >
                    Cancel
                  </button>

                  {/* Save Button */}
                  <button
                    onClick={HandleQuestionsUpdate}
                    className="px-2 py-1 flex font-[400] gap-1 tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-700 hover:text-green-800 hover:border-green-800 hover:shadow-lg"
                  >
                    Save
                  </button>
                </>
              ) : (
                /* Edit Button */
                <button
                  onClick={() => setEditMode(true)}
                  className="px-2 py-1 flex items-center font-[400] gap-1 tracking-[.1em] uppercase border border-blue-600 rounded-lg text-blue-700 hover:text-blue-800 hover:border-blue-800 hover:shadow-lg"
                >
                  Edit <CiEdit />
                </button>
              )}
            </div>
            {/* )} */}
          </th>
        </tr>
      </thead>
      <tbody>
        {questions.map((q, i) => (
          <tr key={q._id}>
            <td className="" key={q._id + "SR" + i}>
              <div className="">
                <span>{i + 1}</span>
              </div>
            </td>

            <td className="" key={q._id + "Question" + (i + 1)}>
              <div className="">
                <textarea
                  type="text"
                  name="question"
                  value={q.question}
                  disabled={!editMode}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleQuestionChange(i, "question", e.target.value);
                  }}
                  className={`text-xs w-full ${
                    editMode
                      ? "text-left input-sm px-2 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
                      : "bg-inherit w-full border-none input-sm px-2 truncate whitespace-normal h-auto"
                  }`}
                />
              </div>
            </td>

            <td className="" key={q._id + "MaxMarks" + (i + 1)}>
              <div>
                <input
                  type="tel"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  name="maxMarks"
                  disabled={!editMode}
                  value={q.maxMarks ?? 0}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleQuestionChange(i, "maxMarks", value);
                    } else {
                      alert("Please enter numbers only.");
                      return false;
                    }
                  }}
                  className={`min-h-9 ${
                    editMode
                      ? "w-full text-left input-sm px-2 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
                      : "bg-inherit w-[100%] border-none px-2 py-2 truncate"
                  }`}
                />
              </div>
            </td>

            <td className="">
              {editMode && (
                <>
                  {i === questions.length - 1 ? (
                    <div className="w-full flex gap-2 justify-start">
                      <button
                        onClick={handleAddQuestion}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-green-700 bg-white shadow-md hover:bg-green-50 active:bg-green-100 focus:outline-none"
                      >
                        <LuPlus className="w-5 h-5 text-green-700" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleDeleteQuestion(i);
                        }}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                      >
                        <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  ) : (
                    <div className=" w-full flex gap-2 justify-start">
                      <button className="flex items-center justify-center w-6 h-6"></button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleDeleteQuestion(i);
                        }}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                      >
                        <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  )}
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default QuestionList;
